import {
  getAuth,
  signInWithPopup,
  GoogleAuthProvider,
  type User,
  type UserCredential,
} from "firebase/auth";
import { initializeApp } from "firebase/app";
import { client } from "@augmodo/lebron-browser-client";
import { client as atlasClient } from "@labeling-tools/api/atlas/client.gen";
import { client as embeddingtonClient } from "@labeling-tools/api/embeddington/client.gen";
import { client as lebronClient } from "@labeling-tools/api/lebron/generated/client.gen";

const firebaseConfig = JSON.parse(import.meta.env.VITE_FIREBASE_CONFIG);
initializeApp(firebaseConfig);
const auth = getAuth();
const provider = new GoogleAuthProvider();

function getCurrentUser(): Promise<User | null> {
  return new Promise((resolve) => {
    const remove = auth.onAuthStateChanged((user) => {
      remove();
      resolve(user);
    });
  });
}

// Initialize clients with base URLs
client.setConfig({
  baseUrl:
    import.meta.env.VITE_LEBRON_BASE_URL || "https://mvp-api.augmoto.com",
});

atlasClient.setConfig({
  baseUrl:
    import.meta.env.VITE_ATLAS_BASE_URL || "https://atlas-api.augmoto.com",
});

lebronClient.setConfig({
  baseUrl:
    import.meta.env.VITE_LEBRON_BASE_URL || "https://mvp-api.augmoto.com",
});

embeddingtonClient.setConfig({
  baseUrl:
    import.meta.env.VITE_EMBEDDINGTON_BASE_URL ||
    "https://embeddington.augmoto.com",
});

// Function to setup auth headers for both clients
function setupAuthHeaders() {
  client.interceptors.request.use(async (config) => {
    const user = auth.currentUser;
    if (user) {
      const token = await user.getIdToken();
      config.headers.set("Authorization", `Bearer ${token}`);
    }
    return config;
  });

  atlasClient.interceptors.request.use(async (config) => {
    const user = auth.currentUser;
    if (user) {
      const token = await user.getIdToken();
      config.headers.set("Authorization", `Bearer ${token}`);
    }
    return config;
  });

  lebronClient.interceptors.request.use(async (config) => {
    const user = auth.currentUser;
    if (user) {
      const token = await user.getIdToken();
      config.headers.set("Authorization", `Bearer ${token}`);
    }
    return config;
  });

  embeddingtonClient.interceptors.request.use(async (config) => {
    const user = auth.currentUser;
    if (user) {
      const token = await user.getIdToken();
      config.headers.set("Authorization", `Bearer ${token}`);
    }
    return config;
  });
}

// Setup auth headers immediately if user is already authenticated
if (auth.currentUser) {
  setupAuthHeaders();
}

// Setup auth headers when user signs in
auth.onAuthStateChanged((user) => {
  if (user) {
    setupAuthHeaders();
  }
});

async function signIn(): Promise<UserCredential> {
  return signInWithPopup(auth, provider);
}

async function signOut(): Promise<void> {
  console.log("SIGN OUT");
  return auth.signOut();
}

function ensureAuthHeaders(): void {
  if (auth.currentUser) {
    setupAuthHeaders();
  }
}

function waitForAuth(): Promise<void> {
  return new Promise((resolve) => {
    if (auth.currentUser) {
      resolve();
    } else {
      const unsubscribe = auth.onAuthStateChanged((user) => {
        if (user) {
          unsubscribe();
          resolve();
        }
      });
    }
  });
}

export {
  signIn,
  signOut,
  getCurrentUser,
  auth,
  ensureAuthHeaders,
  waitForAuth,
};
